import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { SidebarComponent } from '../components/sidebar/sidebar.component';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { MenubarModule } from 'primeng/menubar';
import { ModuleAccessService } from '../services/module-access.service';

@Component({
  selector: 'app-layout',
  imports: [CommonModule, RouterModule, MenubarModule, ButtonModule, SidebarComponent],
  templateUrl: './layout.component.html'
})
export class LayoutComponent {

  userName: string | null = localStorage.getItem('user_name');
  constructor(
    private router: Router,
    private moduleAccessService: ModuleAccessService
  ) {
    const companyId = this.moduleAccessService.getLoggedCompanyId();
    this.moduleAccessService.loadEnabledModules(companyId).subscribe({
      error: () => {
        // Mantem a aplicacao funcional mesmo se houver erro temporario ao carregar modulos.
      }
    });
  }

  public sidebarVisible = true;

  toggleSidebar() {
    this.sidebarVisible = !this.sidebarVisible;
  }

  logout() {
    localStorage.clear();
    this.router.navigate(['/']);
  }
}
